import React from 'react';
import styled from  'styled-components';
import { toPounds } from './../../services/Formats';
import { ExternalLink } from './../../components/Form/ExternalLink';

const AskingQuestionsDiv  = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
  p {
    font-family: 'Nunito Sans',arial;
    font-size: 16px;
    color: #000;
    margin-top: 0px;
    margin-bottom: 3px;
    text-align: center;
  }
  a { color: #000; font-weight: bold; text-decoration: underline; }
  .pounds { color: #209546; font-weight: bold; }
`;

export const AskingQuestions = ({ output, hideLink }) => (
  <AskingQuestionsDiv>
    <p>
      Asking
      {hideLink ? <span> 13 questions </span> : <ExternalLink href='https://advisers.more2life.co.uk/MediaLibrary/More2Life/Research%20docs/13-Health-Questions.pdf'>13 questions</ExternalLink>}
      could make {output.ltv.diff > 0 ? <span className='pounds'> {toPounds(output.ltv.diff)} </span> : false} difference
      to your client.
    </p>
    <p>See how much your client could be offered for different levels of enhancement. </p>
    <p>Click on the people below to see the type of medical circumstances which qualify for each level.</p>
  </AskingQuestionsDiv>
);



// WEBPACK FOOTER //
// ./src/components/LtvCalculator/AskingQuestions.js